<template>
  <v-row no-gutters>
    <v-col cols="12">
      <v-card>
        <v-card-title>
          <h1 class="headline font-weight-medium mb-2 mx-1">
            Проект
          </h1>
          <v-chip v-if="category" small label class="mx-2 mb-2">{{
            category
          }}</v-chip>
          <v-spacer />
          <ActionsModalWindow
            v-if="modal"
            :id="id"
            component-name="Project"
            @close="$emit('close')"
          />
        </v-card-title>
        <v-card-text>
          <v-form v-model="valid">
            <CustomTextField
              v-model="title"
              label="Найменування"
              @input="isChanged = true"
            />

            <CustomTextField
              :value="clientTitle"
              readonly
              disabled
              label="Клієнт"
              class="my-5"
            />

            <v-switch
              v-model="fixPrice"
              label="Fix price"
              color="green"
              class="mb-n7"
              @change="isChanged = true"
            />
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn
            :disabled="!isChanged && valid"
            :loading="loading"
            class="primary-button"
            @click="save"
          >
            Зберегти
          </v-btn>
          <v-btn v-if="!modal" @click="$router.go(-1)">
            Відмінити
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import * as projectsApi from "../../../backend/projectsApi.js";

export default {
  components: {
    ActionsModalWindow() {
      return import("@/components/ActionsModalWindow.vue");
    },
  },
  props: ["id", "modal"],
  data: () => ({
    valid: false,
    title: "",
    clientTitle: "",
    clientId: null,
    fixPrice: false,
    isChanged: false,
    loading: false,
    category: null,
  }),
  async created() {
    const project = await projectsApi.getProject(this.id);
    this.title = project.title;
    this.clientTitle = project.client?.title || "";
    this.fixPrice = project.fixPrice;
    this.category = project.category || "";
  },
  methods: {
    save() {
      this.loading = true;
      projectsApi
        .updateProject(this.id, {
          title: this.title,
          fixPrice: this.fixPrice,
        })
        .then(() => {
          this.modal ? this.$emit("close") : this.$router.go(-1);
        })
        .catch((err) => {
          throw err;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
